import Vue from "vue";
import { PAGE_SIZE } from "@/constants";
import ResourceService from "./resource.service";

class PaginatedService extends ResourceService {
  static getPaginatedPage(page, slug, params) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(this.resource + slug, { params: { page: page, ...params  } })
        .then(({ data }) => {
          const payload = {
            paginationData: {
              totalPages: Math.ceil(data.count / PAGE_SIZE),
              totalRows: data.count,
              activePage: Number(page),
            },
            data: data.data,
          };
          resolve(payload);
        })
        .catch((error) => {
          reject(error)
          // router.push({name: router.currentRoute.name, query: {}})
          // .then(() => router.go())
          // .then(() => reject("Invalid params"));
        });
    });
  }
}

export default PaginatedService;
